"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.brief.topic': 'Topic / brief',
    'socialMediaPlan.brief.topicPlaceholder': 'e.g. New summer collection launch with 20% discount...',
    'socialMediaPlan.brief.goal': 'Post goal',
    'socialMediaPlan.brief.tone': 'Tone',
    'socialMediaPlan.brief.contentType': 'Content type',
    'socialMediaPlan.brief.contentType.image': 'Image',
    'socialMediaPlan.brief.contentType.carousel': 'Carousel',
    'socialMediaPlan.brief.contentType.video': 'Video',
    'socialMediaPlan.brief.contentType.story': 'Story',
    'socialMediaPlan.brief.contentType.thread': 'Thread',
    'socialMediaPlan.brief.audience': 'Target audience',
    'socialMediaPlan.brief.cta': 'Call to action (CTA)',
    'socialMediaPlan.brief.ctaPlaceholder': 'e.g. Shop now, Learn more, Sign up...',
    'socialMediaPlan.brief.platforms': 'Target platforms',
    'socialMediaPlan.brief.platformsHint': 'AI will adjust length, style, and hashtags separately for each selected platform.',
};
